/**
 * Relative time labels shared by the catalog pages. Two flavors: `relTime`
 * renders empty for missing values (home widgets hide the row), `scanLabel`
 * renders an em-dash (table cells keep their column).
 */
const relative = (iso: string | undefined, fallback: string): string => {
  if (!iso) {
    return fallback;
  }
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) {
    return iso;
  }
  const minutes = Math.max(0, Math.round((Date.now() - then) / 60_000));
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} m ago`;
  }
  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `${hours} h ago`;
  }
  return `${Math.round(hours / 24)} d ago`;
};

/** "2 h ago"-style label that renders nothing for missing values. */
export const relTime = (iso: string | undefined): string => relative(iso, '');

/** "2 h ago"-style label with an em-dash for missing values. */
export const scanLabel = (iso: string | undefined): string =>
  relative(iso, '—');
